/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import Table from "../../../components/Table/Table";
import { Header } from "../../../components";
import { RTARectifyBaseColumns } from "../../../utils/utils";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../../layouts/TableLayout/TableLayout";
import useTicketData from "../../../hooks/useTicketData";
import useTicketFilters from "../../../utils/ticketFilters";
import useTicketExport from "../../../hooks/useTicketExport";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";
import { VIEW_TYPE } from "../../../utils/ticketUtils";

function RTARectify() {
  const history = useHistory();

  const {
    searchQuery,
    allRows: filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTicketData("RTA_RECTIFY", true);

  const columns = useMemo(() => {
    const updatedColumns = [...RTARectifyBaseColumns];

    updatedColumns[0] = {
      width: 200,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <TicketButton
          ticketNumber={rowData.ticketNumber}
          ticketId={rowData.id}
        />
      ),
    };

    updatedColumns[6] = {
      width: 165,
      title: "Time Stamp",
      field: "timeStamp",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => {
        const value = rowData.updatedOn;
        return (
          <div style={{ color: "#1F1F1F" }}>
            {value ? new Date(value).toLocaleString() : "Not Received"}
          </div>
        );
      },
    };

    return updatedColumns;
  }, []);

  const { handleExport, isExporting } = useTicketExport("RTA_RECTIFY", columns);

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}
      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </TableLayout>
  );
}

export default RTARectify;
